import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Helper } from '../../common/helper';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private http: HttpClient) { }

  changePassword(userID: number, oldPlainTextPassword: string, newPlainTextPassword: string) {

    // convert to httpPost
    let paramObject = {
      'oldPlainTextPassword': oldPlainTextPassword,
      'newPlainTextPassword': newPlainTextPassword,
    }

    return this.http.post(Helper.API_URL() + '/api/Security/ChangePasswordOWS', paramObject);
  }

  changeExpiredPassword(userID: number, oldPlainTextPassword: string, newPlainTextPassword: string) {

    // convert to httpPost
    let paramObject = {
      'oldPlainTextPassword': oldPlainTextPassword,
      'newPlainTextPassword': newPlainTextPassword,
    }

    return this.http.post(Helper.API_URL() + '/api/Security/ChangeExpiredPassword', paramObject);
  }

}
